import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "tw-flex-1 tw-py-2"
};
export default /*@__PURE__*/ _defineComponent({
    __name: 'sf-skeleton-loader',
    props: {
        height: {
            default: '1rem'
        },
        width: {
            default: '75%'
        },
        shimmer: {
            type: Boolean,
            default: false
        }
    },
    setup (__props) {
        return (_ctx, _cache)=>{
            return _openBlock(), _createElementBlock("div", {
                "data-testid": "skeleton-loader",
                class: _normalizeClass([
                    "tw-flex tw-items-center",
                    {
                        'tw-animate-pulse': !_ctx.shimmer
                    }
                ])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", {
                        style: _normalizeStyle({
                            height: _ctx.height,
                            width: _ctx.width
                        }),
                        class: _normalizeClass([
                            "tw-bg-sf-slate-lighter-1 tw-rounded",
                            {
                                'sf-skeleton-loader__glare': _ctx.shimmer
                            }
                        ])
                    }, null, 6)
                ])
            ], 2);
        };
    }
});
